import React, { Component } from "react"
import { connect, getIn } from "formik"
import Autocomplete from "react-toolbox/lib/autocomplete"
import _ from "lodash"

class FormikAutocomplete extends Component {
  props: {
    formik: any,
    name: string,
  }

  render () {
    const inputProps = _.omit( this.props, [ "formik" ] )

    const { name, formik } = this.props
    const error = getIn( formik.errors, name )
    const touched = getIn( formik.touched, name )
    const value = getIn( formik.values, name )

    return (
      <Autocomplete
        {...inputProps}
        value={value}
        error={touched && error ? error : undefined}
        onChange={formik.handleChange( name )}
        onBlur={formik.handleBlur( name )}
      />
    )
  }
}

export default connect( FormikAutocomplete )



// WEBPACK FOOTER //
// ./src/components/FormikComponents/Autocomplete.jsx